import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController } from 'ionic-angular';
import { GlobalVarApproval } from '@providers/index';

// @IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html'
})
export class ProfilePage {

  profile:any;

  constructor(public navCtrl: NavController, public modalCtrl: ModalController, public globalVar:GlobalVarApproval) {
    this.profile = this.globalVar.app_user;
    console.log(this.profile);

  }

  /**
   * The view loaded, let's query our items for the list
   */
  ionViewDidLoad() {
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/aproval_erp/profile/profile.ts